// Pure scale + tick helpers for the SVG chart kit. No DOM, fully unit-testable.

// Map a value in [domainMin, domainMax] to a pixel length in [0, rangePx].
export function linearScale(domainMax, rangePx, { domainMin = 0 } = {}) {
  const span = domainMax - domainMin || 1; // avoid /0 on a flat series
  return (v) => ((v - domainMin) / span) * rangePx;
}

// Evenly spaced bands across rangePx (categorical x-axis). `padding` (0..1) is
// the fraction of each step left as inter-band gap.
export function bandScale(count, rangePx, { padding = 0.2 } = {}) {
  const n = Math.max(1, count);
  const step = rangePx / n;
  const bandWidth = Math.max(0, step * (1 - padding));
  const offset = (step - bandWidth) / 2;
  return {
    step,
    bandWidth,
    x: (i) => i * step + offset,
  };
}

// "Nice" axis ticks from 0 up to a max ROUNDED UP to a whole step (1/2/5 * 10^n),
// so the top tick is always >= the data max (the gridline never sits below the
// tallest bar).
export function niceTicks(max, count = 4) {
  if (!(max > 0) || !Number.isFinite(max)) return [0];
  const rawStep = max / count;
  const mag = Math.pow(10, Math.floor(Math.log10(rawStep)));
  const norm = rawStep / mag;
  const niceNorm = norm <= 1 ? 1 : norm <= 2 ? 2 : norm <= 5 ? 5 : 10;
  const step = niceNorm * mag;
  if (!(step > 0)) return [0]; // subnormal max → step underflows to 0; degrade, don't hang
  const niceMax = Math.ceil(max / step) * step; // round the domain up so the last tick covers max
  const ticks = [];
  for (let t = 0; t <= niceMax + step * 1e-9; t += step) {
    ticks.push(Math.round(t * 1000) / 1000);
  }
  return ticks;
}
